import { Link } from "react-router-dom";
import WhatsAppButton from "./WhatsAppButton";
import defaultImage from "../assets/logo.jpeg";
import { useTranslation } from "react-i18next";
import { Tag } from "lucide-react";

const ProductCard = ({ product }) => {
  const { t, i18n } = useTranslation();
  const lang = i18n.language;

  return (
    <div className="product-card group">
      {/* Image */}
      <Link to={`/products/${product.id}`} className="block overflow-hidden">
        <div className="aspect-square overflow-hidden">
          <img
            src={product.image || defaultImage} // fallback to default
            alt={lang === "ar" ? product.name_ar : product.name_en}
            className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
          />
        </div>
      </Link>

      {/* Content */}
      <div className="p-6 space-y-4">
        {/* Category Badge */}
        <span className="inline-block px-3 py-1 text-xs font-medium bg-muted text-muted-foreground rounded-full">
          {lang === "ar" ? product.category.name_ar : product.category.name_en}
        </span>

        {/* Title */}

        <Link to={`/products/${product.id}`}>
          <h3 className="text-xl font-serif font-semibold text-foreground hover:text-primary transition-colors">
            {lang === "ar" ? product.name_ar : product.name_en}
          </h3>
        </Link>

        {/* Description */}
        <p className="text-muted-foreground text-sm line-clamp-2">
          {lang === "ar"
            ? product.shortDescription_ar
            : product.shortDescription_en}
        </p>

        {/* Price */}
        {product.price ? (
          <div className="text-2xl font-bold text-primary">
            ${Number(product.price).toFixed(2)}
          </div>
        ) : (
          <div className="flex items-center gap-2 text-muted-foreground">
            <Tag size={18} />
            <span className="text-sm italic">{t("products.priceRequest")}</span>
          </div>
        )}

        {/* WhatsApp Button */}
        <WhatsAppButton
          variant="product"
          productName={lang === "ar" ? product.name_ar : product.name_en}
          productPrice={product.price || t("products.priceRequest")}
        />
      </div>
    </div>
  );
};

export default ProductCard;
